/**
 * Jazyky, ve kterých je dostupné uživatelské rozhraní.
 * Musí odpovídat LanguageConstants.Supported na backendu — němčina je jen torzo překladů,
 * proto se v UI nenabízí.
 */
export const supportedUiLanguages: string[] = ['cs', 'en'];

export const defaultUiLanguage: string = 'cs';

/** Vrátí jazyk, pokud je podporovaný, jinak výchozí. Používej všude, kde přebíráš jazyk zvenčí. */
export function toSupportedUiLanguage(languageIso: string | undefined | null): string {
    return languageIso && supportedUiLanguages.includes(languageIso) ? languageIso : defaultUiLanguage;
}

/**
 * Rozparsuje jazyky firmy uložené jako "cs,en". Nepodporované položky zahazuje
 * a nikdy nevrací prázdno — firma bez jazyka by neuměla založit uživatele.
 * Zrcadlí LanguageConstants.ParseLanguageList na backendu.
 */
export function parseCompanyLanguages(supportedLanguages: string | undefined | null): string[] {
    const parsed = (supportedLanguages ?? '')
        .split(',')
        .map((iso) => iso.trim().toLowerCase())
        .filter((iso) => supportedUiLanguages.includes(iso));

    return parsed.length > 0 ? supportedUiLanguages.filter((iso) => parsed.includes(iso)) : [defaultUiLanguage];
}

export class Languages {

    // Vyhledávací mapa vč. historických jazyků. Němčina se z NABÍDKY jazyků odstranila
    // (2026-07-31), ale starý obsah — kurzy, kapitoly, překlady — ji pořád může nést.
    // U něj se vlaječka musí umět zobrazit, jinak `app-language-flag` (EL-2296) nemá
    // třídu a vlaječku schová.
    private lookup: { [iso: string]: Language } = {
        cs: { flagIcon: 'cz', text: 'Čeština', id: 'cs' },
        en: { flagIcon: 'us', text: 'Angličtina', id: 'en' },
        de: { flagIcon: 'de', text: 'Němčina', id: 'de' },
    };

    getLangByIsoName(langIso: string): Language {
        // Null-safe: neznámý ISO nesmí shodit šablonu. Neutrální položka bez vlaječky
        // je horší než nic, ale lepší než pád bindingu na celém řádku.
        return this.lookup[langIso] ?? new Language(langIso, langIso, '');
    }

    getLangs(): Language[] {
        // Do NABÍDEK jazyků jen jazyky UI (cs/en). Němčina zůstává výhradně ve
        // vyhledávání výše, aby se nevrátila mezi volitelné jazyky.
        return supportedUiLanguages.map((iso) => this.lookup[iso]);
    }

}


export class Language {
    flagIcon: string;
    text: string;
    id: string;

    constructor(id: string = '', text: string = '', flagIcon: string = '') {
        this.id = id;
        this.text = text;
        this.flagIcon = flagIcon;
    }
}
